export default function YouthAttraction() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white mb-6">
            <i className="ri-user-add-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">若い労働力の受け入れ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            若者が集まる<br />
            魅力的な地域へ
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            働く場所と住む場所を同時に提供することで、若い世代の移住を促進。<br />
            地域の活力を取り戻し、持続可能なコミュニティを形成します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/490751c920a6ced263e9b4e5fbde0a40.jpg"
              alt="若者の移住"
              className="w-full h-[500px] object-cover object-top rounded-xl"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              働く場所と住む場所を提供
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              雇用の創出だけでなく、従業員向けの住宅整備や生活支援も行います。都市部からの移住者が安心して新しい生活を始められる環境を整えています。
            </p>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-home-smile-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">従業員住宅の整備</h4>
                  <p className="text-sm text-gray-600">快適な住環境を手頃な価格で提供し、移住のハードルを下げます</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-parent-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">子育て支援</h4>
                  <p className="text-sm text-gray-600">保育施設との連携や育児休暇制度で、子育て世代をサポート</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-community-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">地域コミュニティへの参加</h4>
                  <p className="text-sm text-gray-600">地域イベントや活動を通じて、移住者と地域住民の交流を促進</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">キャリア開発支援</h4>
                  <p className="text-sm text-gray-600">研修制度やスキルアップの機会を提供し、長期的なキャリア形成を支援</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}